import { http } from '../config/config-receituario'

export default {
    listar: async (token) => {
        return http.get('nota-fiscal', {
            headers: {
                'Authorization': token
            }
        })
    },
    salvar: (token, notaFiscal) => {
        return http.post('nota-fiscal', notaFiscal, {
            headers: {
                'Authorization': token
            }
        })
    },
    emitirReceita: (token, receita) => {
        return http.post('nfes/emitir-receita', {receita}, {
            headers: {
                'Authorization': token
            }
        })
    },
    deletar: (token, id) => {
        return http.delete(`nota-fiscal/${id}`, {
            headers: {
                'Authorization': token
            }
        })
    },
    update: (token, notaFiscal) => {
        return http.put(`nota-fiscal/${notaFiscal.id}`, notaFiscal, {
            headers: {
                'Authorization': token
            }
        })
    }

}